/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowstyleminimalhint4Inputs */

const en_aiflowstyleminimalhint4 = /** @type {(inputs: Aiflowstyleminimalhint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Calm, lots of space`)
};

const de_aiflowstyleminimalhint4 = /** @type {(inputs: Aiflowstyleminimalhint4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ruhig, viel Luft`)
};

/**
* | output |
* | --- |
* | "Calm, lots of space" |
*
* @param {Aiflowstyleminimalhint4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowstyleminimalhint4 = /** @type {((inputs?: Aiflowstyleminimalhint4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowstyleminimalhint4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowstyleminimalhint4(inputs)
	return de_aiflowstyleminimalhint4(inputs)
});
export { aiflowstyleminimalhint4 as "aiFlowStyleMinimalHint" }